import React from "react";
import { useTranslation } from "react-i18next";

/** Material-UI */
import { Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "row",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        gap: 8,
        width: "100%",
        fontSize: "clamp(13px, 1vw, 1rem)",
        fontWeight: 600,
        '& + &':{
            paddingTop:8
        },
        "&:not(:first-child)": {
            marginLeft: 16,
        },
        [theme.breakpoints.down("sm")]: {
            flexWrap: "wrap",
            gap: 0,
        },
    },
    sublist: {
        width: "100%",
        padding: theme.spacing(0, 0, 0, 0),
    },
    item: {
        fontSize: "clamp(14px, 2vw, 1.125rem)",
        fontWeight: 400,
        "& span": {
            fontWeight: 600,
        },
        // paddingBottom: 8,
    },
}));

const AktyCard = ({ akt, selected, noTitle }) => {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <>
            {noTitle ? null : (
                <Typography variant={"body1"}>
                    <b>{t("akt.title")}</b>
                    {":"}
                </Typography>
            )}

            <ul className={classes.sublist}>
                <li className={classes.container}>
                    <span className={classes.item}>
                        {t("akt.nazwa")} {":"}&nbsp; <span>{akt.nazwa}</span>
                    </span>
                </li>
                <li className={classes.container}>
                    <span className={classes.item}>
                        {t("akt.miejsce_publikacji")}
                        {":"}&nbsp; <span>{akt.miejsce_publikacji}</span>
                    </span>
                </li>
                <li className={classes.container}>
                    <span className={classes.item}>
                        {t("akt.typ")}
                        {":"}&nbsp; <span>{akt.typ}</span>
                    </span>
                </li>
                <li className={classes.container}>
                    <span className={classes.item}>
                        {t("akt.rodzaj")}
                        {":"}&nbsp; <span>{akt.rodzaj}</span>
                    </span>
                </li>
            </ul>
        </>
    );
};

export default AktyCard;
